import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { formatErr } from "@/lib/api";
import GoogleButton from "@/components/GoogleButton";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try { await login(email, password); nav("/feed"); }
    catch (e) { setErr(formatErr(e)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-[calc(100vh-72px)] grid lg:grid-cols-2">
      <div className="hidden lg:block relative">
        <img className="absolute inset-0 w-full h-full object-cover" alt=""
          src="https://images.unsplash.com/photo-1699914896099-f85498fbbb96?w=1400&q=80" />
        <div className="absolute inset-0 bg-gradient-to-tr from-black/40 to-transparent" />
        <div className="absolute bottom-10 left-10 text-white">
          <p className="overline text-white/80">Welcome back</p>
          <h2 className="h-display text-4xl mt-3 max-w-md">Sign in and keep building your independent business.</h2>
        </div>
      </div>
      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-md" data-testid="login-form">
          <p className="overline mb-3">Log in</p>
          <h1 className="h-display text-4xl mb-8">Good to see you.</h1>
          <GoogleButton testid="login-google"/>
          <div className="flex items-center gap-3 my-6 text-xs uppercase tracking-widest text-[#8A8A8A]">
            <span className="flex-1 h-px bg-[#E5E5E3]"/>or<span className="flex-1 h-px bg-[#E5E5E3]"/>
          </div>
          <label className="block mb-4">
            <span className="text-sm text-[#4A4A4A]">Email</span>
            <input type="email" required value={email} onChange={(e)=>setEmail(e.target.value)}
              className="input mt-1.5" data-testid="login-email" />
          </label>
          <label className="block mb-6">
            <span className="text-sm text-[#4A4A4A]">Password</span>
            <input type="password" required value={password} onChange={(e)=>setPassword(e.target.value)}
              className="input mt-1.5" data-testid="login-password" />
          </label>
          {err && <p className="text-sm text-[#B84B4B] mb-4" data-testid="login-error">{err}</p>}
          <button className="btn-primary w-full" disabled={loading} data-testid="login-submit">
            {loading ? "..." : "Log in"}
          </button>
          <p className="mt-6 text-sm text-[#4A4A4A]">
            New here? <Link to="/register" className="text-[#0A0A0A] underline" data-testid="login-to-register">Become a Hooman</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
